module.exports = __webpack_public_path__ + "img/grey-btn.6b5e972.png";